export default {
  CARD: 'card',
}


// WEBPACK FOOTER //
// ./src/components/ui/MultiSelectDnD/components/ItemTypes.js